"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortBy = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
const utility_1 = require("../utility");
const useSortBy = () => {
    const { options, config, sortby } = (0, hooks_1.useReactifySearchContext)();
    const { track } = (0, hooks_1.useAnalytics)();
    const sortOptions = react_1.default.useMemo(() => {
        return config.sort
            .sort((a, b) => {
            const aInt = typeof a.position === "string"
                ? parseInt(a.position, 10)
                : a.position;
            const bInt = typeof b.position === "string"
                ? parseInt(b.position, 10)
                : b.position;
            return aInt - bInt;
        })
            .filter(({ visibility }) => ["all", options.mode].includes(visibility));
    }, [options.mode, config]);
    const sortOption = react_1.default.useMemo(() => {
        return (sortOptions.find(({ handle }) => handle === sortby.sortOption) ||
            sortOptions[0]);
    }, [sortOptions, sortby.sortOption]);
    const setSortOption = react_1.default.useCallback((sortOptionHandle, ignoreHistoryState = false) => {
        utility_1.debug.log("useSortBy", "setSortOption[sortOptionHandle]", sortOptionHandle);
        sortby.setSortOption(sortOptionHandle);
        if (!ignoreHistoryState) {
            const url = new URL(window.location.href);
            if (url.searchParams.has("sort")) {
                url.searchParams.set("sort", sortOptionHandle);
            }
            else {
                url.searchParams.append("sort", sortOptionHandle);
            }
            window.history.pushState({}, "", url.toString());
        }
        track({
            eventName: "sortChange",
            payload: {
                type: sortOptionHandle,
            },
        });
    }, [window.location.href]);
    utility_1.debug.hook("useSortBy", "sortOption", sortOption);
    utility_1.debug.hook("useSortBy", "sortOptions", sortOptions);
    return {
        sortOptions,
        sortOption,
        setSortOption,
    };
};
exports.useSortBy = useSortBy;
//# sourceMappingURL=useSortBy.js.map